//
// AHT Weight Management — Re-initiation Drug Selection

import type { Pathway } from "../../types/pathway.types";

const OUT_CHAIN = "aht-reinit-drug-chain-out";

export const ahtWtReinitiationDrugSelectPathway: Pathway = {
  id: "aht-wt-reinitiation-drug-select",
  name: "AHT Weight Management — Re-initiation Drug Selection",
  population: "Returning patients for re-initiation of weight management treatment",
  pgdRefs: [],
  demographicConfiguration: { bannerFields: [] },
  entryNode: "aht-reinit-drug-select",

  nodes: [
    {
      id: "aht-reinit-drug-select",
      type: "single_select",
      text: "Which drug is the patient re-initiating?",
      hint: "Re-initiation is only available for patients who were previously on one of these drugs, achieved ≥5% weight loss, and are presenting within 12 months of their last dose.",
      options: [
        { id: "tirzepatide",      label: "Tirzepatide (Mounjaro®)" },
        { id: "semaglutide",      label: "Semaglutide injectable (Wegovy® pre-filled pen)" },
        { id: "oral_semaglutide", label: "Semaglutide oral (Wegovy® tablets)" },
        { id: "foundayo",         label: "Orforglipron (Foundayo® tablets)" },
        { id: "liraglutide",      label: "Liraglutide (Saxenda® / Biolide®)" },
      ],
      routing: {
        tirzepatide:      OUT_CHAIN,
        semaglutide:      OUT_CHAIN,
        oral_semaglutide: OUT_CHAIN,
        foundayo:         OUT_CHAIN,
        liraglutide:      OUT_CHAIN,
      },
      storesTo: "aht-sel-reinitiation-drug",
      required: true,
    },
  ],

  outcomes: {
    [OUT_CHAIN]: {
      id: OUT_CHAIN,
      type: "outcome",
      outcomeType: "chain",
      title: "Loading shared assessment...",
      safetyNetting: [],
      chainId: "aht-wt-reinitiation-drug-select-chain",
    } as any,
  },
};
